import { TextField } from '@material-ui/core';
import HttpIcon from '@material-ui/icons/Http';
import React, { useEffect, useState } from 'react';

import {
  IMonitorNotificationProviderBaseClass,
  IMonitorNotificationProviderBaseClassProps,
} from '~/src/dash/components/monitor/monitor_notifications/notifier';

export interface IMonitorNotifierURLData {
  url: string;
}

export interface IMonitorNotifierURLDataForHistory {
  url: string;
  curl_call: string;
}

interface IProps extends IMonitorNotificationProviderBaseClassProps {}

function MonitorNotifierURLComponent(props: IProps) {
  const data = (props.notifier.Data as IMonitorNotifierURLData) || {};

  const [url, setUrl] = useState(data.url || '');

  useEffect(() => {
    props.onUpdateData(createData());
  }, [url]);

  const createData = function (): IMonitorNotifierURLData {
    // build data
    return {
      url,
    };
  };

  return (
    <TextField
      id='notifier-url-textfield'
      label='Url'
      variant='standard'
      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
        setUrl(target.value);
      }}
      value={url}
      fullWidth
    />
  );
}

export class MonitorNotifierURL implements IMonitorNotificationProviderBaseClass {
  returnData: (data: any) => void = undefined as any;

  Logo = (<HttpIcon style={{ fontSize: 40 }} />);
  Render = (notifier: any) => (
    <MonitorNotifierURLComponent
      notifier={notifier}
      onUpdateData={(data: any) => {
        if (this.returnData !== undefined) {
          this.returnData(data);
        }
      }}
    />
  );

  SetReturnData(cb: (data: any) => void) {
    this.returnData = cb;
  }

  Validate(notifier: any): string {
    if (notifier === undefined) {
      return 'invalid notification';
    }
    const data = (notifier.Data as IMonitorNotifierURLData) || {};
    if (data.url === undefined || data.url === '') {
      return 'url is empty';
    }
    return '';
  }

  IsSuperAdminOnly(): boolean {
    return false;
  }
}
